import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
@Component({
  selector: 'app-people-confirm-dialog',
  templateUrl: './people-confirm-dialog.component.html',
  styleUrls: ['./people-confirm-dialog.component.css']
})
export class PeopleConfirmDialogComponent {

  title: string;
  text: string;
  textAlert: string;
  type: string;

  constructor(
      public dialogRef: MatDialogRef<PeopleConfirmDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
      this.title = data.title;
      this.text = data.text;
      this.textAlert = data.textAlert;
      this.type = data.type;
  }

  onNoClick(result: string): void {
      this.dialogRef.close(result);
  }
}
